<div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.faq_title' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.add_faq_list' | translate }}</p>
          </div>
        </div>

<div class="card">
  <div class="card-body">
    <form (ngSubmit)="onSubmit()" enctype="multipart/form-data">
      <div class="row">

        <!-- Question AR -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">{{ 'MENU.DASHBOARD.question_ar' | translate }}</label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.question_ar' | translate }}"
              [(ngModel)]="formData.question_ar"
              name="question_ar"
              required
            />
          </div>
        </div>

        <!-- Question EN -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">{{ 'MENU.DASHBOARD.question_en' | translate }}</label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.question_en' | translate }}"
              [(ngModel)]="formData.question_en"
              name="question_en"
              required
            />
          </div>
        </div>

        <!-- Answer AR -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">{{ 'MENU.DASHBOARD.answer_ar' | translate }}</label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.answer_ar' | translate }}"
              [(ngModel)]="formData.answer_ar"
              name="answer_ar"
              required
            />
          </div>
        </div>

        <!-- Answer EN -->
        <div class="col-sm-6">
          <div class="mb-3">
            <label class="form-label">{{ 'MENU.DASHBOARD.answer_en' | translate }}</label>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'MENU.DASHBOARD.answer_en' | translate }}"
              [(ngModel)]="formData.answer_en"
              name="answer_en"
              required
            />
          </div>
        </div>

      </div>

      <!-- Submit -->
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-3 d-flex justify-content-start">
            <button type="submit" class="btn btn-primary">{{ 'MENU.DASHBOARD.add' | translate }}</button>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
